import { useQuery } from "@tanstack/react-query";
import { getLoginUsingQR } from "api/services/user-service";
import { IApiResponse } from "api/models/IApiResponse";
import useRefreshToken from "hooks/useRefreshToken";
import { handleApiError } from "helpers/handleApiError";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export const useGetQR = (options?: { enabled?: boolean }) => {
  const { refreshToken, loading: refreshingToken } = useRefreshToken();
   const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();

  const query = useQuery<IApiResponse<{ token: string }>, any>({
    queryKey: ["prepare-qr"],
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      try {
        return await getLoginUsingQR();
      } catch (error: any) {
        if (error?.response?.status === 401 && !refreshingToken) {
          const refreshResponse = await refreshToken();

          if (refreshResponse.success) {
            return await getLoginUsingQR();
          }
        }

        handleApiError(error, { t, enqueueSnackbar });
        throw error;
      }
    },
  });

  return {
    qr: query.data?.data?.token ?? '',
    response: query?.data ?? {},
    loading: (query?.isLoading || query?.isFetching || refreshingToken) ?? false,
    error: query?.error,
    refetch: query?.refetch,
  };
};
